export class Nutraceuticals {
  id = null;
  name = null;
  code = null;
  description = null;
  unit = null;
  route = null;
  content = null;
}
